module.exports = __webpack_public_path__ + "media/petechia.fe17ab3f.wav";